export default __webpack_public_path__ + "static/media/el25.a1178828.svg";